import { request } from "@/interface/helper";

const str = "settingHelp";

export const settingHelp = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/help/list" }),
    add: (data) => request({ data, method: "post", url: "/help/add" }),
    detail: (data) => request({ data, method: "post", url: "/help/detail" }),
    edit: (data) => request({ data, method: "post", url: "/help/modify" }),
    getLangs: (data) => request({ data, method: "get", url: "/help/transfer" }),
    newsDetail: (data) => request({ data, method: "post", url: "/help/getlangdetail" }),
    setOriginal: (data) => request({ data, method: "post", url: "/help/setoriginallanguage" }),
    setLangDetail: (data) => request({ data, method: "post", url: "/help/setlangdetail" }),
    setPublish: (data) => request({ data, method: "post", url: "/help/publishlang" }),
    helpCate: (data) => request({ data, method: "post", url: "/help/helpcate" }),

  },
};
